import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import I18n from '../i18n';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import useIsMount from '../../hooks/use-mount';

export default function ToggleButtonSelection(props) {
  const {onChange, name, value, multiselect, buttonOptions, className, ...rest} = props;
  const [values, setValues] = React.useState(value || '');
  const isMount = useIsMount();

  delete rest.isInvalid;
  delete rest.handleChange;

  React.useEffect(() => {
    setValues(value);
  }, [JSON.stringify(value)]);

  React.useEffect(() => {
    if (!isMount) {
      setValues(values);
      onChange(getOnChangedItems(values));
    }
  }, [values]);

  function getOnChangedItems(changedValue) {
    const selectedItems = buttonOptions.filter(item => changedValue.indexOf(item.value) !== -1);
    return multiselect ? selectedItems : selectedItems[0];
  }

  const onButtonToggle = React.useCallback(changedValue => {
    setValues(changedValue);
  });

  return (
    <ToggleButtonGroup
      type={multiselect ? 'checkbox' : 'radio'}
      name={name}
      value={values}
      className={classnames('toggle-button-selection', 'form-control', className)}
      onChange={onButtonToggle}
      {...rest}
    >
      {buttonOptions.map(item => (
        <ToggleButton key={item.name} value={item.value}>
          {I18n.t(item.name)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

ToggleButtonSelection.defaultProps = {
  multiselect: true,
};

ToggleButtonSelection.propTypes = {
  /** A callback to execute when a button is clicked. */
  onChange: PropTypes.func,
  /** An object passed to the component for button group. */
  buttonOptions: PropTypes.array.isRequired,
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** A name for the toggle button group, required if the type is radio */
  name: PropTypes.string,
  /** Value for the toggle selection button */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /** A bool value to for multiselect or singleselect. */
  multiselect: PropTypes.bool,
};
